// This file can be replaced during build by using the `fileReplacements` array.
// `ng build` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

import { EnvironmentModel } from '@okcargo-apps/shared-infrastructure';

const API_URL = 'https://carriers.demo.okcargo.io';
const LOCAL_VERSION_URL = 'assets/versions.json';

export const environment: EnvironmentModel = {
  production: true,
  // production: false,

  apiUrl: API_URL,
  apiDemoUrl: 'https://carriers.demo.okcargo.io',
  carriersUrl: 'https://carriers.demo.okcargo.io',

  localVersionsUrl: `${LOCAL_VERSION_URL}`,
  versionsUrl: `${API_URL}/${LOCAL_VERSION_URL}`,

  appNameTagline: 'general.carriers',
  utmSource: 'carriers-app',
  termsUrl: 'https://okcargo.com/condiciones-para-el-transportista/',
  privacyUrl: 'https://okcargo.com/politica-de-privacidad/',
};

export const firebaseConfig = {
  apiKey: 'AIzaSyBVRkQPw3tgQPoeop21sH4lfFoGXivzn7c',
  authDomain: 'drivers-stg-b3628.firebaseapp.com',
  projectId: 'drivers-stg-b3628',
  storageBucket: 'drivers-stg-b3628.firebasestorage.app',
  messagingSenderId: '15335209205',
  appId: '1:15335209205:web:fc6b4a61f68fa263aeadbc',
  measurementId: 'G-KP75RQ1B8G',
  vapidKey: 'BAuj4t4pEVONpW86HCEdfkDaVMOqe4UFNU7sehDkNDVMOcXVb_oZeUQrvcHjrv1TvTPaicur2eL6pyzKqrWhWIk',
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
